import { formatMessage } from '@99designs/common/i18n';
import { StructuredBriefFile } from '__generated__/StructuredBriefFile';
import { Uploader } from '__generated__/Uploader';
import DescriptionField from 'projects/components/BriefFields/DescriptionField';
import InspirationFilesField from 'projects/components/BriefFields/InspirationFilesField';
import InspirationUrlsField from 'projects/components/BriefFields/InspirationUrlsField';
import LanguageField from 'projects/components/BriefFields/LanguageField';
import PacklaneFilesField from 'projects/components/BriefFields/PacklaneFilesField';
import TitleField from 'projects/components/BriefFields/TitleField';
import { ObservableForm } from 'projects/components/ObservableForm';
import { MAX_TITLE_LENGTH } from 'projects/consts';
import { trackViewedBriefEvent } from 'projects/events';
import React, { useEffect } from 'react';

interface Fields {
    language: string;
    title: string;
    description: string;
    referenceFiles: StructuredBriefFile[];
    inspirationFiles: StructuredBriefFile[];
    inspirationUrls: string[];
}

export interface Props<T> {
    form: ObservableForm<T>;
    brief: {
        id: string;
        uploader: Uploader;
    };
}

export default function DetailsPage<T extends Fields>(props: Props<T>) {
    const { form, brief } = props;

    useEffect(() => {
        trackViewedBriefEvent({
            id: brief.id,
            page: 'Details',
        });
    }, []);

    return (
        <div className="content-setting">
            <LanguageField form={form} />
            <TitleField
                form={form}
                placeholderText={formatMessage(
                    __('E.g. Packaging for an organic juice company (max {maxSize} characters)'),
                    { maxSize: MAX_TITLE_LENGTH }
                )}
            />

            <DescriptionField
                form={form}
                placeholderText={__(
                    'E.g. I need product packaging for an organic kombucha brand. The product will be 12 x 12 x 12 shipping box. It should feature a retro and vibrant design style and include our company slogan and logo. Our kombucha appeals to adults aged 25 - 40 and is distributed to local bars, corner stores and cafes. The shipping box contains 12 bottles of kombucha. '
                )}
            />

            <PacklaneFilesField form={form} uploader={brief.uploader} />
            <InspirationFilesField form={form} uploader={brief.uploader} />
            <InspirationUrlsField form={form} />
        </div>
    );
}
